import commonRoutes from '@/router/routes/route.common';


export default [...commonRoutes,];
